import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import {
  AgActionIconButtonComponent
} from '@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component';
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { AlertStatus } from '@models/alerts/alerts-enums';
import { Trust } from '@models/trusts/trust';

type ActionEvent = (data: Trust | undefined) => void;

type CellRendererParams = ICellRendererParams<Trust> & {
  openTrustProfile: ActionEvent,
  appointAccountManager: ActionEvent,
  exportTrustProfile: ActionEvent,
  managePins: ActionEvent,
  openAlerts: ActionEvent,
  openNotes: ActionEvent,
};

@Component({
  selector: 'app-ag-trust-actions',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    AgActionIconButtonComponent,
    HasRoleDirective
  ],
  templateUrl: './ag-trust-actions.component.html',
  styleUrl: './ag-trust-actions.component.scss'
})
export class AgTrustActionsComponent implements ICellRendererAngularComp {
  params!: CellRendererParams;
  numberOfAlerts = 0;
  numberOfNewAlerts = 0;

  alertIconClass = "";

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;
    this.numberOfNewAlerts = this.params.data?.alerts?.filter(alert => alert.status === AlertStatus.New && alert.isRead == false).length ?? 0;
    this.numberOfAlerts = this.params.data?.alerts?.length ?? 0;
    this.alertIconClass = "ic-alert-triangle-16 " + (this.numberOfNewAlerts ? "bg-red" : "")
    return true;
  }

  onOpenTrustProfile(): void {
    this.params.openTrustProfile(this.params.data);
  }

  onAppointAccountManager(): void {
    this.params.appointAccountManager(this.params.data);
  }

  onExportTrustProfile(): void {
    this.params.exportTrustProfile(this.params.data);
  }

  onManagePins(): void {
    this.params.managePins(this.params.data);
  }

  onOpenAlerts(): void {
    this.params.openAlerts(this.params.data);
  }

  onOpenNotes(): void {
    this.params.openNotes(this.params.data);
  }
}

